import { React, useEffect, useState } from "react";
import { View, Platform, Dimensions, useWindowDimensions } from "react-native";
import { Card } from "react-native-paper";
import CustomButton from "../../CustomButton/CustomButton";
import { StyleSheet, SafeAreaView } from "react-native";
import CustomQuestion from "../Questions/CustomQuestions";
import CustomInput from "../../CustomInput/CustomInput";
import CustomLabel from "../../CustomLabel/CustomLabel";
import CustomNumericInput from "../../CustomNumericInput/CustomNumericInput";
import { Checkbox } from "react-native-paper";
import { useTheme } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
var width = Dimensions.get("window").width;

const CustomSection = ({
  setAssm,
  finalizeResponse,
  setFinalizeResponse,
  currentStage,
  Stages,
  response_yn,
  setQuestion,
  weight,
  question,
  wfl,
  workflows,
  selectedSteps,
  questLine_type_name,
  setQuestLineTypeName,
  setSelectedSteps,
  question_types,
  sectionTitleChange,
  sectionShowResults,
  sectionInstructionsChange,
  sectionImgUrlChange,
  handleIsSectionCoverChange,
  handleUseOnGraphChange,
  handleGraphAxisChange,
  section_url_img,
  isSectionCover,
  graphAxis,
  useOnGraph,
  sectionQuantitative = false,
  sectionHideComparison,
  sectionInstructions = "",
  sectionName = "",
  sectionId,
  handleQuestionRatingOptionAdd,
  handleQuestionRatingOptionChange,
  handleQuestionRatingOptionRemove,
  handleSectionWeightChange,
  sectionQuestionList,
  sectionQuestionListStage1,
  sectionQuestionListStage2,
  sectionQuestionListStage3,
  handleQuestionAdd,
  handleQuestionChange,
  handleQuestInstructionsChange,
  handleSectionShowResultsChange,
  handleSectionQuantitativeChange,
  handleSectionStepsChange,
  handleSectionHideComparisonChange,
  handleQuestionAddFromAssessment,
  handleQuestionRemove,
  sectionIndex,
  handleQuestionTypeChange,
  handleQuestionOptionAdd,
  handleQuestionLineChange,
  handleQuestionLineAdd,
  handleTccQuestionLineAdd,
  handleDeleteTccAnswerGroup,
  handleQuestionOptionChange,
  handleQuestionLineResp,
  questionOptionResponseList,
  chartOptions,
  chartData,
  noOfUsers,
  handleQuestionOptionRemove,
  isResponse = 0,
  isResult = 0,
  isAnalytics = 0,
  toView = 0,
  Editable = 1,
  handleQuestionLineRemove,
  setInputTypeName,
  assm_submitted,
  isPreview = 0,
  weightMessage,
  questionWeightTotal
}) => {

  //#region Const Definitions
  const { t } = useTranslation();
  const { colors } = useTheme();
  const { width, height } = useWindowDimensions();
  const styles = makeStyles(colors, width, height);
  const isPlatformWeb = Platform.OS === "web" && width > 1300 ? true : false;
  //#endregion

  //#region UseEffect
  useEffect(() => {
    // * No need to do anything here
  }, [width, height]);

  useEffect(() => {
    toView === 0 && handleSectionStepsChange(selectedSteps);
  }, [selectedSteps]);
  //#endregion

  const handleStepSelection = (step) => {
    const updatedSelectedSteps = [...selectedSteps];
    if (updatedSelectedSteps[sectionIndex]?.includes(step)) {
      updatedSelectedSteps[sectionIndex] = updatedSelectedSteps[
        sectionIndex
      ].filter((item) => item !== step);
    } else {
      updatedSelectedSteps[sectionIndex] = [
        ...(updatedSelectedSteps[sectionIndex] || []),
        step,
      ];
    }
    setSelectedSteps(updatedSelectedSteps);
  };

  const renderCheckpoints = () => {
    const renderedCheckpoints = [];
    const wflObj = workflows.find((obj) => obj.assmType === wfl);
    const steps = wflObj ? wflObj.numberOfSteps : 0;
    for (let i = 1; i <= steps; i++) {
      renderedCheckpoints.push(
        <SafeAreaView
          key={`${sectionIndex}-${i}`}
          style={styles.modalCheckBoxRow}
        >
          <Checkbox.Item
            label={t(`common:Step${i}`)}
            status={
              selectedSteps[sectionIndex]?.includes(i) ? "checked" : "unchecked"
            }
            onPress={Editable ? () => handleStepSelection(i) : () => { }}
          />
        </SafeAreaView>
      );
    }
    return renderedCheckpoints;
  };

  return (
    <SafeAreaView style={styles.mainView} noValidate autoComplete="off">

      {/* // * Name of the Section */}
      {toView === 1 && sectionName !== "" && < CustomInput
        value={sectionName}
        editable={false}
        setValue={sectionTitleChange}
        type="SURVEYHEADER1"
        placeholder={sectionName}
      />
      }
      {!toView && !isPreview && !isSectionCover && < CustomInput
        value={sectionName === "" ? "" : sectionName}
        editable={toView == 1 || Editable === 0 ? false : true}
        setValue={sectionTitleChange}
        type="SURVEYHEADER1"
        placeholder={sectionName === "" ? t("common:sectiontitle") : sectionName}
      />}

      {/* // * Instructions for the section */}
      {((!toView || sectionInstructions !== "") && !isSectionCover && !isPreview) && (
        <CustomInput
          value={sectionInstructions === "" ? "" : sectionInstructions}
          editable={toView === 1 || Editable === 0 ? false : true}
          setValue={sectionInstructionsChange}
          type="SURVEYHEADER2"
          placeholder={
            sectionInstructions === ""
              ? "Section Instructions"
              : sectionInstructions
          }
        />
      )}

      {/* //* Image of the section */}
      {toView === 1 ?
        (section_url_img !== '') && <Card style={styles.cardstyle_inv}>
          <Card.Cover source={{ uri: section_url_img }}
            resizeMode={'contain'}
            style={{ flexDirection: 'column', height: 400, backgroundColor: 'white' }} />
        </Card>
        :
        <SafeAreaView>
          {/* // * preview */}
          <SafeAreaView style={styles.row}>
            <CustomInput
              value={section_url_img === "" ? "" : section_url_img}
              editable={toView === 1 || Editable === 0 ? false : true}
              setValue={sectionImgUrlChange}
              type="SURVEYHEADER2"
              placeholder={
                section_url_img === ""
                  ? "Insert Section Image URL"
                  : section_url_img
              }
            />
            <Checkbox.Item
              label={t("common:isSectionCover")}
              status={
                isSectionCover === ""
                  ? (isSectionCover = false)
                  : isSectionCover
                    ? "checked"
                    : "unchecked"
              }
              onPress={Editable ? handleIsSectionCoverChange : () => { }}
            />
          </SafeAreaView>
          {section_url_img !== "" &&
            <Card style={styles.cardstyle_inv}>
              <Card.Cover source={{ uri: section_url_img }}
                resizeMode={'contain'}
                style={{ flexDirection: 'column', height: 100, backgroundColor: 'white' }}
              />
            </Card>
          }
        </SafeAreaView>
      }

      {/* //* create or edit section options and weight totals  */}
      {
        toView === 0 && !isSectionCover && (
          <Card style={styles.cardstyle}>
            <Card.Content>
              <View style={isPlatformWeb && styles.webColumnsContainer}>
                <View style={isPlatformWeb && styles.webColumnLeft}>
                  <Checkbox.Item
                    label={t("common:hidemeetingcomparison")}
                    status={
                      sectionHideComparison === ""
                        ? (sectionHideComparison = false)
                        : sectionHideComparison
                          ? "checked"
                          : "unchecked"
                    }
                    onPress={Editable ? handleSectionHideComparisonChange : () => { }}
                  />
                  <Checkbox.Item
                    label={t("common:showresults")}
                    status={
                      sectionShowResults === ""
                        ? (sectionShowResults = false)
                        : sectionShowResults
                          ? "checked"
                          : "unchecked"
                    }
                    onPress={Editable ? handleSectionShowResultsChange : () => { }}
                  />
                  <Checkbox.Item
                    label={t("common:quantitative")}
                    status={sectionQuantitative ? "checked" : "unchecked"}
                    onPress={Editable ? handleSectionQuantitativeChange : () => { }}
                  />
                  {sectionQuantitative === true && toView === 0 ? (
                    <View style={styles.inputContainer}>
                      <Checkbox.Item
                        label={t("common:useOnGraph")}
                        status={
                          useOnGraph === ""
                            ? (useOnGraph = false)
                            : useOnGraph
                              ? "checked"
                              : "unchecked"
                        }
                        onPress={Editable ? handleUseOnGraphChange : () => { }}
                      />
                      {useOnGraph && <CustomInput
                        value={graphAxis === "" || graphAxis === undefined ? "" : graphAxis}
                        editable={toView === 1 || Editable === 0 ? false : true}
                        setValue={handleGraphAxisChange}
                        type="SURVEYHEADER2"
                        placeholder={
                          graphAxis === "" || graphAxis === undefined
                            ? "Insert X or Y"
                            : graphAxis
                        }
                      />}
                      <CustomLabel value={t("common:weight")} type="ASSM" />
                      {weightMessage && <CustomLabel value={t("common:weightMessage")} type="ASSM" />}
                      <CustomNumericInput
                        value={weight !== undefined || weight !== '' ? weight : 0}
                        setValue={handleSectionWeightChange}
                        editable={Editable === 0 ? false : true}
                        min={0}
                        max={100}
                        type="SM_MYPROFILE"
                      />
                      <CustomLabel value={t("common:totalSectionQuestions") + questionWeightTotal[sectionIndex] + '%'} type="ASSM" />
                    </View>
                  ) : (
                    <></>
                  )}
                </View>
                {/* // TODO Disabled Read Only To Who for now as I am not sure what the functionality is */}
                {false && toView === 0 && (
                  <View style={isPlatformWeb && styles.webColumnRight}>
                    <CustomLabel value={t("common:ROTW")} type="ASSM" />
                    {renderCheckpoints().map((checkpoint, index) => (
                      <View key={index}>{checkpoint}</View>
                    ))}
                  </View>
                )}
              </View>
            </Card.Content>
          </Card>
        )
      }

      {toView === 0 && <View style={styles.line} />}
      {!isSectionCover &&
        <SafeAreaView>
          {sectionQuestionList.map((singleQuestion, index) => (
            <Card style={styles.cardstyle} key={index}>
              {/* //* Image of the section */}
              {toView === 1 ?
                (singleQuestion.questImgUrl !== '' && singleQuestion.questImgUrl !== undefined) &&
                <>
                  <Card.Cover source={{ uri: singleQuestion.questImgUrl }}
                    resizeMode={'contain'}
                    style={{ flexDirection: 'column', height: 400, backgroundColor: 'white' }} />
                </>
                :
                <SafeAreaView>
                  {/* preview */}
                  <SafeAreaView style={styles.row}>
                    <CustomInput
                      value={singleQuestion.questImgUrl === "" || singleQuestion.questImgUrl === undefined ? "" : singleQuestion.questImgUrl}
                      editable={toView === 1 || Editable === 0 ? false : true}
                      setValue={(img) => handleQuestionChange('', singleQuestion.id, sectionId, sectionIndex, 0, 0, -1, img, undefined)}
                      type="SURVEYHEADER2"
                      placeholder={
                        singleQuestion.questImgUrl === "" || singleQuestion.questImgUrl === undefined
                          ? "Insert Question Image URL"
                          : singleQuestion.questImgUrl
                      }
                    />
                    <Checkbox.Item
                      label={t("common:isQuestCover")}
                      status={
                        singleQuestion.isQuestionCover === "" || singleQuestion.isQuestionCover === undefined
                          ? (singleQuestion.isQuestionCover = false)
                          : singleQuestion.isQuestionCover
                            ? "checked"
                            : "unchecked"
                      }
                      onPress={Editable ? () => handleQuestionChange('', singleQuestion.id, sectionId, sectionIndex, 0, 0, -1, undefined, !singleQuestion.isQuestionCover) : () => { }}
                    />
                  </SafeAreaView>
                  {singleQuestion.questImgUrl !== "" && singleQuestion.questImgUrl !== undefined &&
                    <Card style={styles.cardstyle_inv}>
                      <Card.Cover source={{ uri: singleQuestion.questImgUrl }}
                        resizeMode={'contain'}
                        style={{ flexDirection: 'column', height: 100, backgroundColor: 'white' }}
                      />
                    </Card>
                  }
                </SafeAreaView>
              }
              <Card.Content>
                <CustomQuestion
                  qType={question}
                  setQType={setQuestion}
                  textFieldQuestionName="question_name"
                  questionName={singleQuestion.question_name}
                  textFieldQuestionInstructions="quest_instructions"
                  questionInstructions={singleQuestion.quest_instructions}
                  questionId={singleQuestion.id}
                  questionIndex={index}
                  sectionId={sectionId}
                  sectionQuantitative={sectionQuantitative}
                  sectionIndex={sectionIndex}
                  question_types={question_types}
                  handleQuestionChange={handleQuestionChange}
                  handleQuestInstructionsChange={handleQuestInstructionsChange}
                  handleQuestionTypeChange={handleQuestionTypeChange}
                  handleQuestionRatingOptionRemove={handleQuestionRatingOptionRemove}
                  input_type_name={singleQuestion.input_type_name}
                  setInputTypeName={setInputTypeName}
                  setQuestLineTypeName={setQuestLineTypeName}
                  quest_controls={singleQuestion.quest_controls}
                  allow_mutiple_option_answers_yn={singleQuestion.allow_mutiple_option_answers_yn}
                  question_required_yn={toView ? singleQuestion.quest_isRequired : singleQuestion.question_required_yn}
                  questionOption={singleQuestion.question_options}
                  questionLines={singleQuestion.question_lines}
                  questionLinesStage1={sectionQuestionListStage1 === undefined ? undefined : sectionQuestionListStage1[index]?.question_lines}
                  questionLinesStage2={sectionQuestionListStage2 === undefined ? undefined : sectionQuestionListStage2[index]?.question_lines}
                  questionLinesStage3={sectionQuestionListStage3 === undefined ? undefined : sectionQuestionListStage3[index]?.question_lines}
                  questweight={singleQuestion.question_weight}
                  singleQuestion={singleQuestion}
                  handleQuestionLineAdd={handleQuestionLineAdd}
                  handleQuestionOptionAdd={handleQuestionOptionAdd}
                  handleQuestionOptionChange={handleQuestionOptionChange}
                  handleTccQuestionLineAdd={handleTccQuestionLineAdd}
                  handleDeleteTccAnswerGroup={handleDeleteTccAnswerGroup}
                  handleQuestionLineChange={handleQuestionLineChange}
                  questionOptionResponseList={questionOptionResponseList}
                  handleQuestionRatingOptionChange={handleQuestionRatingOptionChange}
                  handleQuestionLineResp={handleQuestionLineResp}
                  handleQuestionLineRemove={handleQuestionLineRemove}
                  chartOptions={chartOptions}
                  chartData={chartData}
                  noOfUsers={noOfUsers}
                  handleQuestionOptionRemove={handleQuestionOptionRemove}
                  handleQuestionRatingOptionAdd={handleQuestionRatingOptionAdd}
                  Editable={Editable}
                  isResponse={isResponse}
                  isResult={isResult}
                  isAnalytics={isAnalytics}
                  toView={toView}
                  assm_submitted={assm_submitted}
                />

                {(toView === 0 && Editable === 1) && (
                  <SafeAreaView>
                    {sectionQuestionList.length !== 1 && (
                      <CustomButton
                        onPress={() => handleQuestionRemove(index, sectionIndex)}
                        iconName="trash-outline"
                        show="HOME_BELL"
                        type="HOME_BELL"
                        textTop="0"
                        sz={30}
                      />
                    )}
                  </SafeAreaView>
                )}
              </Card.Content>
              {(toView === 0 && Editable === 1) && (
                <Card.Actions>
                  <SafeAreaView style={styles.questionButtons}>
                    {/* //* Limit the number of sections, when maximume section number is reached the button disappears   */}
                    {sectionQuestionList.length - 1 === index &&
                      sectionQuestionList.length < 4 && (
                        <SafeAreaView style={styles.main}>
                          <View style={styles.rowBtn}>
                            <CustomButton
                              text={t('common:addQuestion')}
                              onPress={() => handleQuestionAdd(index, sectionIndex)}
                              iconName='add-outline'
                              show='SURVEY'
                              type='SURVEY'
                              isGradient={true}
                              textTop='0'
                              sz={25}
                            />
                          </View>
                        </SafeAreaView>
                      )}
                  </SafeAreaView>
                </Card.Actions>
              )}
            </Card>
          ))}
        </SafeAreaView>
      }
    </SafeAreaView >
  );
};

const makeStyles = (colors) =>
  StyleSheet.create({
    main: {
      alignContent: "center",
    },
    cardstyle: {
      margin: 20,
      backgroundColor: colors.background_card,
      borderRadius: 15,
      elevation: 10,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.5,
      shadowRadius: 10,
    },
    cardstyle_inv: {
      margin: 20,
      backgroundColor: colors.background_card,
      borderRadius: 0,
      elevation: 0,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0,
      shadowRadius: 0,
    },
    row: {
      flexDirection: "row",
    },
    modalCheckBoxRow: {
      flex: 1,
      marginleft: 50,
      marginright: 100,
      marginRight:
        Platform.OS === "web" && width > 1300 ? (width * 60) / 100 : 60,
      flexDirection: "row",
      justifyContent: "space-between",
      padding: 10,
    },
    labelWFL: {
      flexDirection: "row",
    },
    webColumnsContainer: {
      flex: 1,
      flexDirection: "row",
      width: "100%",
    },
    webColumnLeft: {
      width: "50%",
    },
    webColumnRight: {
      width: "50%",
    },
    inputContainer: {
      flex: 1,
      padding: 13,
      width: "100%",
      borderTopColor: colors.buttons_primary,
      borderTopWidth: StyleSheet.hairlineWidth,
      marginBottom: "2%",
      justifyContent: "space-between",
    },
    line: {
      borderBottomColor: colors.buttons_primary,
      borderBottomWidth: StyleSheet.hairlineWidth,
      marginBottom: "1%",
    },
    rowBtn: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
  });

export default CustomSection;
